import {
  BoundDeviceCategoryType,
  DesignGroupType,
  UnboundDeviceCategoryType,
} from '@/graphql/creator-platform/generated'
import { useNewProductStore } from '@/store/newProductStore'
import {
  type BoundDeviceProductIndicator,
  type NewProductIndicator,
} from '@/store/newProductStore.type'

const phoneCaseNewIndicator: BoundDeviceProductIndicator = {
  categoryType: BoundDeviceCategoryType.PhoneCase,
  deviceHandle: 'iphone-16-pro',
  deviceColorHandle: 'black-titanium-505153',
  productHandle: 'clear-case-bumper',
  colorHandle: 'transparent',
}
export const designGroupTypeToNewIndicator: Record<DesignGroupType, NewProductIndicator> = {
  [DesignGroupType.General]: phoneCaseNewIndicator,
  [DesignGroupType.PhoneCase]: phoneCaseNewIndicator,
  [DesignGroupType.Grip]: {
    categoryType: UnboundDeviceCategoryType.Grip,
    productHandle: 'grip-max-magsafe',
    colorHandle: 'black',
  },
  [DesignGroupType.GripO]: {
    categoryType: UnboundDeviceCategoryType.Grip,
    productHandle: 'grip-o-v2-magsafe',
    colorHandle: 'black',
  },
  [DesignGroupType.AquaStand]: {
    categoryType: UnboundDeviceCategoryType.AquaStand,
    productHandle: 'aquastand-stainless-steel-700ml-without-straw',
    colorHandle: 'white',
  },
  [DesignGroupType.AquaStandNemo]: {
    categoryType: UnboundDeviceCategoryType.AquaStand,
    productHandle: 'aquastand-stainless-steel-480ml-without-straw',
    colorHandle: 'shell-beige',
  },
  [DesignGroupType.AirPodsCase]: {
    categoryType: BoundDeviceCategoryType.AirPodsCase,
    deviceHandle: 'airpods-pro-2',
    deviceColorHandle: null,
    productHandle: 'airpods-case-bundle-front',
    colorHandle: 'black',
  },
  [DesignGroupType.AirTagCase]: {
    categoryType: BoundDeviceCategoryType.AirTagCase,
    deviceHandle: 'airtag',
    deviceColorHandle: null,
    productHandle: 'airtag-case',
    colorHandle: 'black',
  },
  [DesignGroupType.IPadCase]: {
    categoryType: BoundDeviceCategoryType.IPadCase,
    deviceHandle: 'ipad-air-6-110inch',
    deviceColorHandle: 'awesome-white',
    productHandle: 'ipad-case-bumper',
    colorHandle: 'ultimate-gray-2',
  },
}

export async function checkAndResetProduct(
  designGroupTypeOfArtwork: DesignGroupType,
): Promise<void> {
  const productStore = useNewProductStore()
  await productStore.init()
  const boundDesignGroupType =
    productStore.productState?.selectedProduct?.productSet.boundDesignGroup.type ?? null
  if (boundDesignGroupType === null) {
    throw new Error('boundDesignGroupType is null')
  }
  if (designGroupTypeOfArtwork !== boundDesignGroupType) {
    await productStore.changeByIndicator(designGroupTypeToNewIndicator[designGroupTypeOfArtwork])
  }
}

export const EVENT_TAG = '36738905-f50e-43bf-b1f2-0c920747da19'
